var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 15.7917L7.79101 14.6917C3.49935 10.8 0.666016 8.23333 0.666016 5.08333C0.666016 2.51667 2.68268 0.5 5.24935 0.5C6.69935 0.5 8.09101 1.175 8.99935 2.24167C9.90768 1.175 11.2993 0.5 12.7493 0.5C15.316 0.5 17.3327 2.51667 17.3327 5.08333C17.3327 8.23333 14.4993 10.8 10.2077 14.7L8.99935 15.7917Z",
    fill: "#004594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHeart);
export default __webpack_public_path__ + "static/media/full_heart.dff3261faf10cdd461be439c7b8b703b.svg";
export { ForwardRef as ReactComponent };